import { z } from 'zod'

export const loginSchema = z.object({
  email: z.string().email('E-mail inválido'),
  password: z.string().min(8, 'Senha deve ter ao menos 8 caracteres'),
})

export const registerSchema = z.object({
  name: z.string().min(2, 'Nome deve ter ao menos 2 caracteres').max(100),
  email: z.string().email('E-mail inválido'),
  password: z.string().min(8, 'Senha deve ter ao menos 8 caracteres'),
})

const numericField = z.preprocess(
  v => (v === '' || v === undefined || v === null) ? undefined : Number(v),
  z.number().positive().optional(),
)

export const dealSchema = z.object({
  title: z.string().min(5, 'Título deve ter ao menos 5 caracteres').max(200),
  description: z.string().max(2000).optional(),
  url: z.string().url('URL inválida'),
  affiliateUrl: z.string().url('URL inválida').optional().or(z.literal('')),
  price: numericField,
  originalPrice: numericField,
  couponCode: z.string().max(50).optional(),
  freeShipping: z.boolean().default(false),
  publishToSocials: z.boolean().default(false),
  publishToTelegram: z.boolean().default(false),
  publishToX: z.boolean().default(false),
  storeId: z.string().min(1, 'Selecione uma loja'),
  categoryId: z.string().min(1, 'Selecione uma categoria'),
  expiresAt: z.string().optional(),
  imageUrl: z.string().url('URL da imagem inválida').optional().or(z.literal('')),
})

export const storeSchema = z.object({
  name: z.string().min(2, 'Nome deve ter ao menos 2 caracteres').max(100),
  websiteUrl: z.string().url('URL do site inválida'),
  logoUrl: z.string().url('URL do logo inválida').optional().or(z.literal('')),
  description: z.string().max(500).optional(),
  isActive: z.boolean().default(true),
})

export const categorySchema = z.object({
  name: z.string().min(2, 'Nome deve ter ao menos 2 caracteres').max(100),
  icon: z.string().max(10).optional().or(z.literal('')),
  color: z.string().max(20).optional().or(z.literal('')),
  parentId: z.string().nullable().optional(),
})

export const couponSchema = z.object({
  code: z.string().min(2, 'Código deve ter ao menos 2 caracteres').max(50),
  description: z.string().max(500).optional(),
  discount: z.string().max(100).optional(),
  storeId: z.string().min(1, 'Selecione uma loja'),
  expiresAt: z.string().optional(),
  isVerified: z.boolean().default(false),
})

export type LoginForm = z.infer<typeof loginSchema>
export type RegisterForm = z.infer<typeof registerSchema>
export type DealForm = z.infer<typeof dealSchema>
export type StoreForm = z.infer<typeof storeSchema>
export type CategoryForm = z.infer<typeof categorySchema>
export type CouponForm = z.infer<typeof couponSchema>
